<template>
  <div v-if="section?.length" class="flex flex-col gap-y-56">
    <component
      :is="wrapperComponent"
      v-for="(block, index) in section"
      :key="block.id"
      class="w-full empty:hidden"
      :class="{ 'rounded-lg overflow-hidden': rounded }"
      :width="wrapperType === 'container' ? getBlockWidth(block) : undefined"
    >
      <BlockRenderer
        :id="block.id"
        :block-position="index + 1"
        :data-test="block.id"
        :hidden-devices="block.hiddenDevices"
        :props="block.props"
        :type="block.type"
        :with-bottom-margin="false"
      />
    </component>
  </div>
</template>

<script setup lang="ts">
import type { ApiBlock } from '@backmarket/http-api/src/api-specs-content/models/block'

import { getBlockWidth } from '../utils/blockWidth'

import BlockRenderer from './BlockRenderer/BlockRenderer.vue'
import Container from './Container.vue'

const {
  wrapperType = 'container',
  section,
  rounded,
} = defineProps<{
  section?: ApiBlock[]
  rounded?: boolean
  wrapperType?: 'container' | 'div'
}>()

const wrapperComponent = wrapperType === 'container' ? Container : 'div'
</script>
